import { CodeBook } from "@king-ict/eupisi-ui/models";

import { PersonAddress } from "../Request";
import { SchoolYear } from "../SchoolYear/SchoolYear";
import { GenderEnum } from "../Shared";
import { SchoolCandidateStatus } from "./SchoolCandidateStatus";
//import { Address } from "../Shared/Address";

export interface SchoolCandidate {
    id: number;
    schoolYearId: number;
    oib?: string;
    firstName:	string;
    lastName:	string;
    dateOfBirth: Date;
    genderId: GenderEnum;
    motherName?: string;
    fatherName?: string;
    residence?: PersonAddress;
    //permanentAddress?: Address;
    //temporaryAddress?: Address;
    permanentAddressNote?:	string;
    schoolCandidateAddReasonId?: number;
    schoolCandidateAddReasonOther?: string;
    schoolCandidateCancelReasonId?: number;
    schoolCandidateCancelReasonOther?: string;
    institutionId?: number;
    statusId: SchoolCandidateStatus;
    alternativeCode?: string;
    schoolCandidateAlternativeCodeReasonId?: number;
    schoolCandidateAlternativeCodeTypeId?: number;
    uoguCountyId: number;

    // These are used in details
    schoolYear?: SchoolYear;
    isOibConnected: boolean;
    uoguNote?: string;
    isHandicapped: boolean;
}

export const getDefaultSchoolCandidate = (): SchoolCandidate => {
    return {
        id: 0,
        schoolYearId: 0,
        firstName: "",
        lastName: "",
        dateOfBirth: new Date(),
        genderId: GenderEnum.Male, // Does not allow null or Unknown
        statusId: SchoolCandidateStatus.notSent,
        uoguCountyId: 0,

        isOibConnected: false,
        isHandicapped: false,
    };
};